import {
  delOrder, getOrderById, getOrderPage, exportExcelOrder, refund, getWaitExpressCount, cashbackMountByOrder, getOrderDistribution,
  refuseRefund
} from '@/api/order'
import { message } from 'ant-design-vue'
import { useExportExcel } from '@/hooks'
export class OrderController {
  static orderStatusMap = new Map([
    [0, { key: 0, title: '待支付', color: 'yellow' }],
    [1, { key: 1, title: '已支付，待发货', color: 'blue' }],
    [2, { key: 2, title: '取消订单', color: 'orange' }],
    [3, { key: 3, title: '已退款', color: '#f50' }],
    [4, { key: 4, title: '完成', color: 'green' }],
    [5, { key: 5, title: '申请退款', color: 'red' }],
    [6, { key: 6, title: '已发货', color: 'success' }],
    [100, { key: 100, title: '拒绝退款', color: 'success' }]
  ])

  static orderStatusList = [
    { key: 0, title: '待支付', color: 'yellow' },
    { key: 1, title: '已支付', color: 'blue' },
    { key: 2, title: '取消订单', color: 'yelorangelow' },
    { key: 3, title: '已退款', color: 'warn' },
    { key: 4, title: '完成', color: 'green' },
    { key: 5, title: '申请退款', color: 'red' },
    { key: 6, title: '已发货', color: 'success' },
    { key: 100, title: '拒绝退款', color: 'success' }
  ]

  static async page (params: COMMON.API.QueryParams) {
    const { code, data } = await getOrderPage(params)

    return {
      code,
      data: data.records,
      sum: data.total
    }
  }

  static async refuseRefund (data: {'orderId': string, refundReason?: string}) {
    const { code, msg } = await refuseRefund(data)
    code === 0 ? message.success('拒绝退款成功') : message.error(msg)
    return code
  }

  static async orderDistribution (id: string) {
    return await getOrderDistribution(id)
  }

  static async del (id: string) {
    const { code, msg } = await delOrder(id)
    code === 200 ? message.success('删除成功') : message.error(msg)
  }

  static async byId (id: string) {
    const { code, data } = await getOrderById(id)
    return data as unknown as ORDER.Detail
  }

  static async exportExcelOrder (params) {
    const data = await exportExcelOrder(params)
    useExportExcel(data as any, '订单')
  }

  static async refund (data: {'orderId': number, }) {
    const { code, msg } = await refund(data)
    code === 0 ? message.success('允许退款成功') : message.error(msg)
  }

  static async getWaitExpressCount () {
    const { data } = await getWaitExpressCount()
    return data
  }

  static async cashbackMountByOrder (order: string, cashbackMount) {
    const { code, msg } = await cashbackMountByOrder(order, cashbackMount)
    code === 0 ? message.success('记录成功') : message.error(msg)
    return code
  }
}
